// extracted by mini-css-extract-plugin
export default {"desktopTaxFeeContainer":"wOvCda","mobileTaxFeeContainer":"wqldXj"};